
define('modules/application/wizard/classes/mainBus',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {
  /**
   * This is the main module object, it contains the main views (titlebar & content) and the main model
   */
  var mainBus   = _.extend({}, genericElement, {

    Views : {

      /**
       * This view manage the title bar of this section
       */
      titleBar  : genericElement.Views.titleBar.extend({
        template  : "application/wizard/sections/mainBus/titleBar",
        tagName   : "h3",
        initialize: function(){
          genericElement.Views.titleBar.prototype.initialize.apply(this);
          this.model.bind('change', this.setLabel, this);
          this.model.bind('packages:fetching', this.setLoadingLabel, this);
          this.model.bind('packages:fetched',  this.setLabel, this);
        },

        setLabel  : function(){
          var caption           =   this.$el.find(".caption");
          var labelContent      =   $.i18n._(this.model.get("packageClassLabel"));

          if ((labelContent)&&(labelContent!==""))
          {
            if (caption.is(".hidden"))
              caption.hide(0, function() {
                $(this).removeClass("hidden");
                caption.html(labelContent);
                caption.fadeIn(200);
              });
            else
              caption.html(labelContent);
          }
          else
            if (!caption.is(".hidden"))
              caption.fadeOut(200, function() {$(this).addClass("hidden");});
        },

        setLoadingLabel : function() {
          var caption           =   this.$el.find(".caption"),
              labelContent      =   $.i18n._("IDS_W4_9010");

          if (caption.is(".hidden"))
            caption.hide(0, function() {
              $(this).removeClass("hidden");
              caption.html(labelContent);
              caption.fadeIn(200);
            });
          else
            caption.html(labelContent);
        }
      }),

      /**
       * This view manage the content of this section
       */
      content   : genericElement.Views.content.extend({

        template      : "application/wizard/sections/mainBus/content",
        serialize     : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },
        events        : {
          "change select[name='powerSupply']" : "updateValues"
        },

        initialize    : function() {
          genericElement.Views.content.prototype.initialize.apply(this);

          //Binding events
          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",  this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",    this.accessoryLineChosenEventHandler, this);

          this.model.unbind("render:requested",               this.render);
          this.model.bind("render:requested",                 this.render, this);

          this.model.unbind("packages:fetched",               this.packagesFetchedEventHandler);
          this.model.bind("packages:fetched",                 this.packagesFetchedEventHandler, this);

          this.model.unbind("product:fetching",               this.showLoader);
          this.model.bind("product:fetching",                 this.showLoader, this);
        },

        updateValues                    : function() {
          var newPackageClassId = this.$el.find("select[name='powerSupply']").val();
          this.model.set("packageClassId", newPackageClassId);
        },

        packagesFetchedEventHandler     : function() {
          this.$el.find(".loadingSection").hide();
          this.$el.find(".regularSection").show();
          this.render();
        },

        showLoader                      : function() {
          this.$el.find(".regularSection").hide();
          this.$el.find(".loadingSection").show();
        },

        //Event handlers
        accessoryLineChosenEventHandler : function(accessoryLineId) {
          this.showLoader();
          this.model.fetchPackages();
        },

        afterRender                     : function() {
          this.$el.find("input[rel='alreadyStyled']").removeAttr("rel");
          this.$el.find(".select").remove();
          window.customizeFormElements.call();
        }

      })
    },

    /**
     * The main model for this section, it store infos about the plant type and a reference to the model that
     * manage the power supply section
     */
    Model : genericElement.Model.extend({

      defaults : {
        inhibited       : false
      },

      initialize        : function()  {
        window.BticinoS4B.eventAggregator.unbind("load:Project",          this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",            this.loadProject,       this);

        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",  this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",    this.deliverModel,      this);

        this.unbind("change:packageClassId",                this.addPackageDetails);
        this.bind("change:packageClassId",                  this.addPackageDetails, this);

        this.bind("product:fetched",                        this.renderPackage,     this);
      },

      deliverModel      : function()  {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.mainBus = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.mainBus = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.mainBus = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.mainBus = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.mainBus = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.mainBus = this;
              break;
          };           
        BticinoS4B.Instances.Models.ApplicationModel.set("mainBus", this);

        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i            = 0;

        dataProvider.addItems("externalItems", {
          productCode       : this.get("productCode"),
          productLabel      : this.get("productLabel"),
          packageClassLabel : this.get("packageClassLabel"),
          kitValue          : this.get("kitValue"),
          partOfKit         : this.get("partOfKit"),
          quantity          : 1,
          price             : this.get("price")
        });

        if (this.get("secondaryProducts"))
        {
          for (i=0; i<this.get("secondaryProducts").length; i++)
          {
            dataProvider.addItems("externalItems", {
              productCode       : this.get("secondaryProducts")[i].productCode,
              productLabel      : this.get("secondaryProducts")[i].productLabel,
              packageClassLabel : this.get("secondaryProducts")[i].packageClassLabel,
              kitValue          : this.get("kitValue"),
              partOfKit         : this.get("partOfKit"),
              quantity          : 1,
              price             : this.get("secondaryProducts")[i].price
            });
          }
        }
      },

      addPackageDetails : function()  {
        var fetchedPackages         = this.get("fetchedPackages"),
            selectedPackageClassId  = this.get("packageClassId"),
            selectedPackages        = _.filter(fetchedPackages, function(iterablePackage) {
              return  iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage         = selectedPackages.length>0 ? selectedPackages[0] : undefined;

        this.fetchProduct(selectedPackage);
      },

      renderPackage     : function(packageToRender)  {
        if (packageToRender)
          _.extend(this.attributes, packageToRender);

        this.trigger("render:requested");
      },

      fetchPackages     : function()  {
        this.trigger("packages:fetching");
        var that                          = this,
            //Defining race conditions variables
            powerSupplyDataFetchCompleted = false.
            i                             = 0;

        //Defining success callbacks
        var powerSupplyPackageFetchSuccessCallback  = function(data) {
          var fetchedPackages = data.packages;

          for (i=0; i<fetchedPackages.length; i++)
          {
            if ( fetchedPackages[i].specialVars  &&  fetchedPackages[i].specialVars!==""  &&  typeof(fetchedPackages[i].specialVars)!=="object" )
              fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);
          }

          that.set("fetchedPackages", fetchedPackages);

          if (!that.get("packageClassId"))
            that.set("packageClassId", fetchedPackages[0].packageClassId);
          else
            that.addPackageDetails();

          that.trigger("render:requested");
        };

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(803, powerSupplyPackageFetchSuccessCallback,  undefined, true);
      },

      fetchProduct      : function(packageToValorize) {
        var that = this;

        if (!packageToValorize.isPopulated)
        {
          this.trigger("product:fetching");
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageToValorize.packageClassId, function(data){
            var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

            _.extend(packageToValorize, mainProduct);
            packageToValorize.secondaryProducts = secondaryProducts;

            packageToValorize.isPopulated = true;

            that.trigger("product:fetched", packageToValorize);
          }, true);
        }
        else
        {
          this.trigger("product:fetched", packageToValorize);
        }
      },

      loadProject       : function(model) {
        this.attributes.packageClassId = model.mainBus.packageClassId;
      }

    })
  });

  // Required, return the module for AMD compliance
  return mainBus;
});